import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CreateFirmRequest, FirmResponseDto, FirmSummaryDto, UpdateFirmRequest } from '../models/firm.dto';

@Injectable({ providedIn: 'root' })
export class FirmService {
  private readonly base = `${environment.baseUrl}/api/v1/firms`;

  constructor(private readonly http: HttpClient) {}

  createFirm(dto: CreateFirmRequest): Observable<FirmResponseDto> {
    return this.http.post<FirmResponseDto>(`${this.base}/`, dto);
  }

  getCurrentFirm(): Observable<FirmResponseDto> {
    return this.http.get<FirmResponseDto>(`${this.base}/me/`);
  }

  updateCurrentFirm(dto: UpdateFirmRequest): Observable<FirmResponseDto> {
    return this.http.patch<FirmResponseDto>(`${this.base}/me/`, dto);
  }

  getMyFirms(): Observable<FirmSummaryDto[]> {
    return this.http.get<FirmSummaryDto[]>(`${this.base}/mine/`);
  }

  switchActiveFirm(firmId: string): Observable<FirmResponseDto> {
    return this.http.put<FirmResponseDto>(`${this.base}/active/`, { firmId });
  }
}
